import axios from 'axios'
import Cookies from 'js-cookie'

export const api = axios.create({});
api.interceptors.request.use((config) => {
  const token = import.meta.env.DEV ? localStorage.getItem('token') : Cookies.get('GATEWAY');
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

let isRefreshing = false;
let failedQueue: any[] = [];
const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

api.interceptors.response.use(response => response, async (error) => {
  const originalRequest = error.config;
  if (error.response?.status === 401 && !originalRequest._retry && Cookies.get('HASH_SESSION')) {
    if (isRefreshing) {
      // Если обновление токена уже идет, ставим запрос в очередь
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      }).then(() => {
        originalRequest.headers['Authorization'] = 'Bearer ' + (import.meta.env.DEV ? localStorage.getItem('token') : Cookies.get('GATEWAY'));
        return api(originalRequest);
      }).catch(err => Promise.reject(err));
    }

    originalRequest._retry = true;
    isRefreshing = true;

    try {
      if(import.meta.env.DEV && !localStorage.getItem('refresh_token')) {
        return
      }
      const data = (await axios.post('/proxy/account-recovery-api.bpmn/auth/login/refresh/token', {
        "refreshToken": import.meta.env.DEV ? localStorage.getItem('refresh_token') : ''
      })).data;
      if(import.meta.env.DEV) {
        localStorage.setItem('token', data.access_token)
        localStorage.setItem('refresh_token', data.refresh_token)
      }
      const newToken = data.access_token;
      api.defaults.headers.common['Authorization'] = 'Bearer ' + newToken;
      processQueue(null, newToken);
      originalRequest.headers['Authorization'] = 'Bearer ' + newToken;
      return api(originalRequest);
    } catch (err) {
      localStorage.removeItem('token')
      localStorage.removeItem('refresh_token')
      processQueue(err, null);
      return Promise.reject(err);
    } finally {
      isRefreshing = false;
    }
  }

  return Promise.reject(error);
});
